import React from 'react';

function Navbar() {
  return (
    <nav className="navbar tc-navbar-style5">
      <div className="container">
        <div className="col-lg-6 d-none d-lg-block">
          <div className="nav-links">
            <a href="tel:+917899009244" className="me-5">
              <i className="la la-tty cir-icon"></i>
              <span className="txt"> +91 78990 09244</span>
            </a>
            <a href="mailto:hello@mavinsky.com" >
              <i className="la la-envelope cir-icon"></i> 
              <span className="txt"> hello@mavinsky.com </span>
            </a>
          </div>
        </div>

        <div className="col-lg-3 text-lg-end">
          <div className="nav-btns">
            <a
              href="#contact-link"
              className="butn border rounded-pill border-brown1 hover-bg-brown1 text-uppercase color-brown1"
            >
              <span> Contact Us</span>
            </a>
            {/* <a href="#" className="icon ms-4 side_menu_btn">
              <span>
                <i className="la la-grip-lines"></i>
              </span>
            </a> */}
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
